<template>
  <div class="detail-page">
    <!-- 列表 -->
    <div class="table-section">
      <div class="table-container" ref="tableContainer">
        <el-table
          :data="dataList"
          class="detail-table"
          :height="tableHeight"
          :header-cell-style="tableHeaderStyle"
          :cell-style="tableCellStyle"
          @sort-change="handleSortChange">
          <el-table-column prop="id" label="序号" width="80" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="vweightKg" label="体重" min-width="140" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.vweightKg}}Kg 【{{props.row.sweightKg}}Kg】
            </template>
          </el-table-column>
          <el-table-column prop="bmi" label="BMI" min-width="120" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.vbmi}} 【{{props.row.sbmi}}】
            </template>
          </el-table-column>
          <el-table-column prop="moistureRate" label="水份" min-width="140" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.vwaterPercentage}}% 【{{props.row.swaterPercentage}}%】
            </template>
          </el-table-column>
          <el-table-column prop="boneRate" label="骨骼肌率" min-width="140" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.vbodySkeletal}}% 【{{props.row.sbodySkeletal}}%】
            </template>
          </el-table-column>
          <el-table-column prop="bodyAge" label="身体年龄" min-width="120" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.vbodyAge}}岁【{{props.row.sbodyAge}}岁】
            </template>
          </el-table-column>
          <el-table-column prop="fatRate" label="体脂" min-width="140" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.vfat}}% 【{{props.row.sfat}}%】
            </template>
          </el-table-column>
          <el-table-column prop="visceralFatRate" label="内脏脂肪" min-width="120" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.vvisceralFat}} 【{{props.row.svisceralFat}}】
            </template>
          </el-table-column>
          <el-table-column prop="muscleRate" label="肌肉" min-width="140" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.vmusclePercentage}}% 【{{props.row.smusclePercentage}}%】
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="170" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="Operation" label="操作" width="100" align="center" fixed="right">
            <template slot-scope="props">
              <div class="action-group">
                <el-tooltip effect="dark" content="查看详情" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-view" @click="clickdialogEdit(props.row)"></el-link>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page_no"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="page_size"
        layout="total, prev, pager, next, sizes, jumper"
        :total="dataListnum">
      </el-pagination>
    </div>

    <!-- 查看详情 -->
    <el-dialog title="查看详情" :visible.sync="dialogEdit" width="50%" top="5vh" class="newAdd detail-dialog" append-to-body>
      <div class="addUser_body">
        <el-form ref="userMsg" :model="editData" label-width="100px">
          <el-form-item label="体重"><el-input v-model="editData.vweightKg" disabled><template slot="append">
                <span class="input-unit">{{ editData.sweightKg }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="理想体重"><el-input v-model="editData.vbodyStandardWeightKg" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyStandardWeightKg }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="BMI"><el-input v-model="editData.vbmi" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbmi }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="BMR"><el-input v-model="editData.vbmr" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbmr }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="腰臀"><el-input v-model="editData.vwhr" disabled><template slot="append">
                <span class="input-unit">{{ editData.swhr }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="内脏脂肪"><el-input v-model="editData.vvisceralFat" disabled><template slot="append">
                <span class="input-unit">{{ editData.svisceralFat }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="体脂"><el-input v-model="editData.vfat" disabled><template slot="append">
                <span class="input-unit">{{ editData.sfat }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="骨骼肌率"><el-input v-model="editData.vbodySkeletal" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodySkeletal }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="骨骼肌量"><el-input v-model="editData.vbodySkeletalKg" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodySkeletalKg }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="左臂肌肉"><el-input v-model="editData.vmuscleKgLeftArm" disabled><template slot="append">
                <span class="input-unit">{{ editData.smuscleKgLeftArm }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="右臂肌肉"><el-input v-model="editData.vmuscleKgRightArm" disabled><template slot="append">
                <span class="input-unit">{{ editData.smuscleKgRightArm }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="左臂脂肪比率"><el-input v-model="editData.vbodyFatRateLeftArm" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyFatRateLeftArm }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="右臂脂肪比率"><el-input v-model="editData.vbodyFatRateRightArm" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyFatRateRightArm }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="左腿肌肉"><el-input v-model="editData.vmuscleKgLeftLeg" disabled><template slot="append">
                <span class="input-unit">{{ editData.smuscleKgLeftLeg }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="右腿肌肉"><el-input v-model="editData.vmuscleKgRightLeg" disabled><template slot="append">
                <span class="input-unit">{{ editData.smuscleKgRightLeg }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="左腿脂肪比率"><el-input v-model="editData.vbodyFatRateLeftLeg" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyFatRateLeftLeg }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="右腿脂肪比率"><el-input v-model="editData.vbodyFatRateRightLeg" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyFatRateRightLeg }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="躯干肌肉"><el-input v-model="editData.vmuscleKgTrunk" disabled><template slot="append">
                <span class="input-unit">{{ editData.smuscleKgTrunk }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="躯干脂肪比率"><el-input v-model="editData.vbodyFatRateTrunk" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyFatRateTrunk }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="水分类"><el-input v-model="editData.vwaterPercentage" disabled><template slot="append">
                <span class="input-unit">{{ editData.swaterPercentage }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="皮下脂肪"><el-input v-model="editData.vbodyFatSubCutPercentage" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyFatSubCutPercentage }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="身体年龄"><el-input v-model="editData.vbodyAge" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyAge }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="健康评价"><el-input v-model="editData.vbodyHealth" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyHealth }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="健康评分"><el-input v-model="editData.vbodyScore" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyScore }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="肌肉"><el-input v-model="editData.vmusclePercentage" disabled><template slot="append">
                <span class="input-unit">{{ editData.smusclePercentage }}</span></template>
            </el-input></el-form-item>
          <el-form-item label="肥胖等级"><el-input v-model="editData.vbodyFatGrade" disabled><template slot="append">
                <span class="input-unit">{{ editData.sbodyFatGrade }}</span></template>
            </el-input></el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 查看详情 End -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      queryData: {
        terminalUserId: ''
      },
      dataList: [],
      dataListnum: 0,
      tableHeight: 480,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: '',
      dialogEdit: false,
      editData: {},
    }
  },
  mounted () {
    this.$nextTick(this.initTableResizeObserver)
  },
  beforeDestroy () {
    this.destroyTableResizeObserver()
  },
  methods: {
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted, #F5F6F8)', color: 'var(--aptus-text-secondary, #5E6670)', fontWeight: '600' }
    },
    tableCellStyle () {
      return { textAlign: 'center' }
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    LoadData (row) {
      this.queryData.terminalUserId = row.id
      this.BodyFatScalesList()
      this.BodyFatScalesNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.BodyFatScalesList()
      this.BodyFatScalesNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.BodyFatScalesList()
      this.BodyFatScalesNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.BodyFatScalesList()
      this.BodyFatScalesNum()
    },
    clickQuery () {
      this.page_no = 1
      this.BodyFatScalesList()
      this.BodyFatScalesNum()
    },
    clickQueryReset () {
      this.clickQuery()
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData = row
    },
    BodyFatScalesList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.terminalUserId = that.queryData.terminalUserId
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_BodyFatScalesList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    BodyFatScalesNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.terminalUserId = that.queryData.terminalUserId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_BodyFatScalesNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-page {
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #E2E6EC;
  overflow: hidden;
}

.detail-table {
  /deep/ .el-table__body td {
    padding: 10px 0;
    background: #FFFFFF;
    border-bottom: 1px solid #EFF1F5;
  }

  /deep/ .el-table__body tr:hover > td {
    background: #EFF6FF !important;
  }

  /deep/ .el-table__header th {
    padding: 10px 0;
    background: #F5F6F8 !important;
    border-bottom: 1px solid #E2E6EC;
    color: #5E6670;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: #EFF6FF;
    }
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #E2E6EC;
}

/* 弹窗 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid #EFF1F5;
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: #F5F6F8;
  border-bottom: 1px solid #EFF1F5;
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1A1D21;
}

.detail-dialog /deep/ .el-dialog__body {
  padding: 20px 24px;
  max-height: calc(90vh - 140px);
  overflow-y: auto;
}

.addUser_body {
  padding: 0 46px 0 30px;
}

.input-unit {
  width: 100px;
  display: inline-block;
  text-align: center;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: #2563EB;
  border-color: #2563EB;
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: #3B82F6;
    border-color: #3B82F6;
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: #2563EB;
  background: #EFF6FF;
  border-color: #A8D0F5;

  &:hover {
    background: #2563EB;
    color: #FFF;
    border-color: #2563EB;
  }
}
</style>
